import { createAsyncThunk } from "@reduxjs/toolkit";
import { checkForChatTokenAPI, generateChatTokenAPI, getUserInfoAPI, mostTrackedUsersAPI, removeChatTokenAPI, searchTwitterUserAPI } from "../apis/auth";

export const searchTwitterUser = createAsyncThunk("list/searchTwitterUser", (usernames: string) => searchTwitterUserAPI(usernames));
export const getUserInfo = createAsyncThunk("list/getUserInfo", () => getUserInfoAPI());
export const checkForChatToken = createAsyncThunk("list/checkForChatToken", () => checkForChatTokenAPI());
export const generateChatToken = createAsyncThunk("list/generateChatToken", () => generateChatTokenAPI());
export const removeChatToken = createAsyncThunk("list/removeChatToken", () => removeChatTokenAPI());
export const mostTrackedUsers = createAsyncThunk("list/mostTrackedUsers", () => mostTrackedUsersAPI());
